export default __webpack_public_path__ + "static/ai-powered-development-34d7a8dc28379c901dd0667ead69eaa2.png";